// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1ov8-","row":"ProcedureTreatmentSummary_row__35Kb7"};